import { Box, Text, Link } from '@chakra-ui/react'
import HelpPopoverTrigger from '../../../../components/UI/HelpPopoverTrigger'
import CustomPopover from 'components/UX/CustomPopover'
import React from 'react'

export const createGroupButtonHelperPopover: React.ReactNode = (
  <CustomPopover customTrigger={HelpPopoverTrigger}>
    <Box px={4} py={6}>
      <Text>
        <b>Tip</b>: Remember to create and add data collectors to this team.
      </Text>
      <br />
      <Text>
        For more, visit our{' '}
        <Text as="b">
          <Link mx={2} fontWeight="semibold" color="gray.400" href="/auth/help">
            help and training
          </Link>
        </Text>{' '}
        section.
      </Text>
    </Box>
  </CustomPopover>
)

export const createGroupHelperPopover = (
  <CustomPopover customTrigger={HelpPopoverTrigger}>
    <Box px={4} py={6}>
      <Text>
        Use this page to create a new team. Teams house several communities that data collectors can
        use to capture data.
      </Text>
      <br />
      <Text>
        For more, visit our{' '}
        <Text as="b">
          <Link mx={2} fontWeight="semibold" color="gray.400" href="/auth/help">
            help and training
          </Link>
        </Text>{' '}
        section.
      </Text>
    </Box>
  </CustomPopover>
)

export const createCommunityHelperSteps = [
  {
    selector: '.group-type-select',
    content: 'Select the type of team you want to create from the dropdown.'
  },
  {
    selector: '.group-leader-input',
    content: 'Enter the name of the team leader, this is the person who will manage the team.'
  },
  {
    selector: '.community-location-map',
    content:
      'Use the map to select the location of the community. You can also use the "Use my current location" button to automatically select your current location.'
  },
  {
    selector: '.community-use-my-location-button',
    content: 'Click this button to automatically select your current location.'
  }
]
